import React from 'react'
import Panel from '../Panel'
import { Button } from 'hljd'
import { Exhibition } from 'hlj-components'
import {
  CHARGE_STATUS_SUCCESS,
  REFUND_STATUS_NOT_APPLY,
  REFUND_STATUS_FAILED,
  CHARGE_STATUS_FAILED
} from '@components/JiaMeng/NewCustomer/constant'
import style from './style.module.less'
import columns from './columns'
import brokerageOrderColumns from './brokerageOrderColumns'

/**
 *  体验店签单卡片
 */
const CooperateOrderCard = ({ store, item }) => {
  const { cooperateorder_card } = item
  let { brokerage_orders, id, show_apply_button } = cooperateorder_card || {}
  brokerage_orders = brokerage_orders || []
  return (
    <Panel
      icon="//qnm.hunliji.com/o_1d8n8sluc1ko736ags1ee75e6t.png"
      item={item}
    >
      <Exhibition columns={columns} data={item} />

      {brokerage_orders.map((brokerage_order, index) => {
        const { id: brokerage_id, status, refund_status } = brokerage_order
        // 账单大于1时显示账单index
        const showIndex = brokerage_orders.length > 1
        // 是否显示发起退款按钮
        const showApplyReturnBtn =
          status == CHARGE_STATUS_SUCCESS &&
          (refund_status == REFUND_STATUS_NOT_APPLY ||
            refund_status == REFUND_STATUS_FAILED)
        return (
          <div key={brokerage_id} className={style.brokerageOrder}>
            {showIndex && (
              <div className={style.brokerageOrderTitle}>账单{index + 1}</div>
            )}
            <div className={style.brokerageOrderContent}>
              <Exhibition
                columns={brokerageOrderColumns}
                data={brokerage_order}
              />

              <div className="text-right">
                {status == CHARGE_STATUS_FAILED && (
                  <Button
                    onClick={() =>
                      store.openApplyDeductFeeModal(id, brokerage_id)
                    }
                  >
                    重新申请
                  </Button>
                )}

                {showApplyReturnBtn && (
                  <Button
                    onClick={() => store.openApplyReturnFeeModal(brokerage_id)}
                  >
                    发起退款
                  </Button>
                )}
              </div>
            </div>
          </div>
        )
      })}

      {show_apply_button && (
        <Button
          type="primary"
          onClick={() => store.openApplyDeductFeeModal(id)}
          style={{ marginTop: 10 }}
        >
          申请扣除服务费
        </Button>
      )}
    </Panel>
  )
}

export default CooperateOrderCard
